module.exports = __webpack_public_path__ + "static/media/img--mobile@2x.36b5fc7d.png";